import axios from 'axios';
import { mutate } from 'swr';
import { Notistack } from '@shared/components/Notistack/Notistack';
import { getError } from '@shared/utils/helpers';
import { SERVICES } from '@shared/constants/apiConfig';
import { withQueryParams } from '@shared/commonFunctions';
import { IDealSheet } from './interfaces';

const path = `/${SERVICES.ACCOUNTING}`;

export const requestCreateDealSheet = (data: unknown) => {
  return mutate(path, async() => {
    try {
      await axios.post(`${path}/accounting`, data);
      Notistack.successMessage('DealSheet - Created Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const requestCreateNegative = (id: string, data: unknown) => {
  return mutate(path, async() => {
    try {
      await axios.post(`${path}/accounting/negative/dealsheet/${id}`, data);
      Notistack.successMessage('Negative DealSheet- Converted Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const requestNegative = async(id: string) => {
  try {
    const response = await axios.get(`${path}/accounting/convert/negative/${id}`);
    return response;
  } catch (err) {
    Notistack.generalError(getError(err));
  }
};

export const requestPDF = async(id: string) => {
  try {
    const response = await axios.get(`${path}/accounting/pdf/${id}`);
    return response;
  } catch (err) {
    Notistack.generalError(getError(err));
  }
};

export const requestGetNewDealSheet = async (dealId: string) => {
  try {
    const response = await axios.get<IDealSheet>(`${path}/accounting/getnewdeelsheet/${dealId}`);

    return response?.data;
  } catch (err) {
    Notistack.generalError(`Error during fetching dealsheet information - ${getError(err)}`);
  }
};


export const requestUpdateFundedDate = async (id: string, fundedDate: string | null) => {
  try {
    await axios.put(withQueryParams(`${path}/accounting/dealsheet/${id}/fundedDate`,{fundedDate}, false));
    Notistack.successMessage('Funded Date Updated Successfully');
  } catch (err) {
    Notistack.generalError(getError(err));
  }
};
